import { ImmutabilityContext } from '../effects/customImmutabilityContext';
import {
  PostEditorFirstCommentUpdateAction,
  PostEditorReducerFunction,
  PostEditorToggleFirstCommentAction
} from '../PostEditorActions';
import { OnStateUpdateCallbackFunction, postGroupStateUpdater } from '../../helpers/postGroupStateUpdater';
import { validatorStateUpdater } from '../../validators/helpers/validatorStateUpdater';
import { ErrorMessageSeverity } from '../../../../constants/form';
import { canAddComment } from '../../helpers/canAddComment';
import { PostEditorErrorKeys } from '../../../../models/validator-props';
import { GroupPostAttributesType } from '../../../../models/post-editor';

export const firstCommentUpdateReducer: PostEditorReducerFunction<PostEditorFirstCommentUpdateAction['payload']> = (
  state,
  payload
) => {
  const { update: updateImmutable } = ImmutabilityContext;
  const { postGroupIndex, customizeIndex, text } = payload;
  const callback: OnStateUpdateCallbackFunction = currentPost =>
    updateImmutable(currentPost, {
      content: {
        firstComment: {
          $set: text
        }
      }
    });
  const result = postGroupStateUpdater(state, postGroupIndex, customizeIndex, 'content', callback);
  return validatorStateUpdater(result, postGroupIndex, ErrorMessageSeverity.warning, [
    'instagramHashtagLimit',
    'instagramFacebookFirstCommentCharLimit',
    'linkedinFirstCommentCharLimit',
    'profileRequired'
  ]);
};

export const toggleFirstCommentReducer: PostEditorReducerFunction<PostEditorToggleFirstCommentAction['payload']> = (
  state,
  payload
) => {
  const { update: updateImmutable } = ImmutabilityContext;
  const { postGroupIndex, customizeIndex, selectedProfiles } = payload;
  let showComment = false;
  const callback: OnStateUpdateCallbackFunction = currentPost =>
    updateImmutable<GroupPostAttributesType>(currentPost, {
      content: {
        shouldShowFirstComment: {
          $apply: current => {
            if (!currentPost.customizedProfileId) {
              showComment = !current;
              return showComment;
            }
            const selectedProfile = selectedProfiles.find(p => p.id === currentPost.customizedProfileId);
            if (!selectedProfile) {
              showComment = !current;
              return showComment;
            }
            const canAddCommentResult = canAddComment([selectedProfile], currentPost.content.postFeedType);
            if (canAddCommentResult) {
              showComment = !current;
              return showComment;
            }
            showComment = false;
            return showComment;
          }
        }
      }
    });
  let errorKeys: PostEditorErrorKeys[] = ['profileRequired', 'instagramHashtagLimit'];
  if (!showComment)
    errorKeys = [...errorKeys, 'instagramFacebookFirstCommentCharLimit', 'linkedinFirstCommentCharLimit'];
  const result = postGroupStateUpdater(state, postGroupIndex, customizeIndex, 'content', callback);
  return validatorStateUpdater(result, postGroupIndex, ErrorMessageSeverity.warning, errorKeys);
};
